





















































import { Prop, Component, Vue, Inject } from 'vue-property-decorator'
import { ActionAPI, ContactAPI, ReferralAPI } from '@/api/backend-client'
import { Referral } from '@/api/model/referral'
import { ActionType, ReferralStatus } from '@/api/types'
import { Action } from '@/api/model/action'
import { v4 as uuid } from 'uuid'
import { CreateActionModel } from '@/components/form/CreateActionForm.vue'

@Component
export default class ActivityTabs extends Vue {
    @Prop({ required: true }) readonly referral!: Referral
    @Inject() reloadReferral!: () => Promise<void>

    showCompleted: boolean = false
    modalCreateAction: boolean = false
    submittingCreateAction: boolean = false
    formCreateAction: CreateActionModel = { notify: false, actionDate: null }

    get label() {
        return this.showCompleted ? this.$t('referral.show-upcoming') : this.$t('referral.show-completed')
    }

    get isAssigned(): boolean {
        return this.referral.assignedTo !== null
    }

    get componentClass() {
        return {
            'contact-information': true,
        }
    }

    get variables() {
        return {
        }
    }

    get canEdit(): boolean {
        if (!this.$currentCompany || !this.referral || !this.referral.assignedToBranch) {
            return false
        }

        return this.$currentCompany.id === this.referral.assignedToBranch.company.id
    }

    get contact() {
        if (!this.referral || !this.referral.contact) {
            return null
        }

        return this.referral.contact
    }

    async createAction(): Promise<void> {
        this.submittingCreateAction = true

        // If we created a meeting action.
        if (this.formCreateAction.type === ActionType.MEETING) {
            const statusses = [
                ReferralStatus.NEW,
                ReferralStatus.PENDING,
                ReferralStatus.UNREACHABLE,
            ]

            // If one of above status
            if (statusses.includes(this.referral.status)) {

                // Ask if we should update referral status also.
                if (confirm(this.$t('edit-task-modal.change-status-to-appointment').toString())) {

                    await ReferralAPI.update(this.referral.id, {
                        ...this.referral,
                        status: ReferralStatus.APPOINTMENT,
                        statusReason: null,
                    } as Referral)
                }
            }
        }

        // api
        await ActionAPI.create({
            ...Action.fromData({
                referral: this.referral,
                type: this.formCreateAction.type,
                appointmentType: this.formCreateAction.appointmentType,
                actionDate: this.formCreateAction.actionDate,
                assignedTo: this.formCreateAction.assignedTo,
                comment: this.formCreateAction.comment,
                id: uuid(),
                createdBy: this.$currentUser.resourceIdentifier,

            }),

            // @todo: not actually part of the model, should be a seperate call
            // @ts-ignore
            informAssignedTo: this.formCreateAction.notify,
        })

        await this.reloadReferral()
        this.submittingCreateAction = false
        this.modalCreateAction = false
        this.formCreateAction = { notify: false }

    }

    get sortedActions() {
        return this.referral.actions
            .filter(action => action instanceof Action)
            .sort((a: Action, b: Action) => a.actionDate > b.actionDate ? 1 : -1)
            .map((action: Action) => ({
                ...action,
                referral: this.referral,
            }))
    }
}
